import { render } from "./BreAd.vue?vue&type=template&id=81cc1f1e"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/package/BreAd.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "81cc1f1e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('81cc1f1e', __exports__)) {
    api.reload('81cc1f1e', __exports__)
  }
  
  module.hot.accept("./BreAd.vue?vue&type=template&id=81cc1f1e", () => {
    api.rerender('81cc1f1e', render)
  })

}


export default __exports__